import React, { Component } from 'react';
import classnames from 'classnames';
import Tooltip from '../Tooltip';

import getImageClassByType from './getImageClassByType';

export default class Buttonlet extends Component {
  static displayName = 'Buttonlet';
  state = {
    isTooltipActive: false,
  };

  showTooltip = () => {
    this.setState({ isTooltipActive: true });
  };

  hideTooltip = () => {
    this.setState({ isTooltipActive: false });
  };

  iamme = (element) => {
    this.element = element;
  };

  render() {
    const {
      disabled,
      focused,
      onClick,
      local,
      override,
      type,
      spin,
      style,
      title,
      tooltipData,
      tooltipTimeout,
    } = this.props;
    const { isTooltipActive } = this.state;

    const buttonletClass = classnames(
      'buttonlet fa-stack',
      (type !== 'delete-contact') && 'fa-lg',
      (disabled || onClick === undefined) ? 'buttonlet-disabled' : 'buttonlet-enabled',
      local && 'buttonlet-local',
      focused && 'buttonlet--focused',
    );

    const buttonletCircleClass = classnames(
      'fa fa-circle fa-stack-2x',
      override && 'buttonlet-override-circle',
    );

    const buttonletImageClass = classnames(
      'fa fa-inverse fa-stack-1x',
      getImageClassByType(type),
      override && 'buttonlet-override-stack',
      spin && 'fa-spin',
    );

    return (
      <span
        className={classnames(buttonletClass, ` buttonlet-${type}`)}
        onClick={onClick}
        style={style}
        title={title}
        ref={this.iamme}
        onMouseMove={this.showTooltip}
        onMouseLeave={this.hideTooltip}
      >
        <span className={buttonletCircleClass} />
        <span className={buttonletImageClass} />
        <span className="u-visually-hidden">{type}</span>
        <ButtonletTooltip
          active={isTooltipActive}
          data={tooltipData}
          parent={this.element}
          tooltipTimeout={tooltipTimeout}
        />
      </span>
    );
  }
}

function ButtonletTooltip({
  active, data, parent, tooltipTimeout,
}) {
  if (!data) {
    return null;
  }
  return (
    <Tooltip
      data={data}
      active={active}
      parent={parent}
      tooltipPos="top"
      tooltipTimeout={tooltipTimeout}
    />
  );
}